// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiRoute from "lumi-rescript/lib/es6/src/LumiRoute.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Util$Dashboard from "./Util.res.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Panel$Dashboard from "./Panel.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Map$LumiFacilityMap from "lumi-facility-map/lib/es6/src/Map.res.js";
import * as Sensor$LumiDocuments from "lumi-documents/lib/es6/src/Sensor.res.js";
import * as SpotDetails$Dashboard from "./SpotDetails.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as Facility$LumiDocuments from "lumi-documents/lib/es6/src/Facility.res.js";
import * as Stallingsnet$LumiCentral from "lumi-central/lib/es6/src/Stallingsnet.res.js";
import * as Barrier$LumiAuthentication from "lumi-authentication/lib/es6/src/Barrier.res.js";
import * as ObjectStyle$LumiFacilityMap from "lumi-facility-map/lib/es6/src/ObjectStyle.res.js";

function calcSelectedSensorState(state, selectedSensorKey) {
  return {
    facilityMap: state.facilityMap,
    facilityInfo: state.facilityInfo,
    sensorInfos: state.sensorInfos,
    sensorStyles: state.sensorStyles,
    sensorStates: state.sensorStates,
    selectedSensorState: state.sensorStates.find(param => Primitive_object.equal(selectedSensorKey, param.sensorKey))
  };
}

function calcSensorStyles(state) {
  let selectedSensorKey = Stdlib_Option.map(state.selectedSensorState, param => param.sensorKey);
  return {
    facilityMap: state.facilityMap,
    facilityInfo: state.facilityInfo,
    sensorInfos: state.sensorInfos,
    sensorStyles: Belt_Map.mapWithKey(state.sensorInfos, (sensorKey, param) => ObjectStyle$LumiFacilityMap.make(param.name, undefined, undefined, undefined, [
      [
        "is-active",
        Primitive_object.equal(selectedSensorKey, sensorKey)
      ],
      [
        "is-upper-place",
        Util$Dashboard.isUpperPlace(param.placeClass)
      ]
    ], undefined)),
    sensorStates: state.sensorStates,
    selectedSensorState: state.selectedSensorState
  };
}

function useFacilityMaps(mbFacilityMapKey, selectedSensorKey, facilityMapUrl, propFacilityInfos) {
  let toAuth = Barrier$LumiAuthentication.Dispatch.useContext();
  let reducer = LumiReactReducer.useReducerWithDependencies({
    mbFacilityMapKey: mbFacilityMapKey,
    selectedSensorKey: selectedSensorKey,
    facilityInfos: propFacilityInfos
  }, param => {
    let mbFacilityMapKey = param.mbFacilityMapKey;
    return {
      TAG: "InitWithEffect",
      _0: {
        facilityMap: undefined,
        facilityInfo: mbFacilityMapKey !== undefined ? param.facilityInfos.find(param => Belt_Map.has(param.maps, mbFacilityMapKey)) : undefined,
        sensorInfos: Sensor$LumiDocuments.Schema.$$Map.empty(),
        sensorStyles: Map$LumiFacilityMap.SensorStyles.empty,
        sensorStates: [],
        selectedSensorState: undefined
      },
      _1: param => {
        let dispatch = param.dispatch;
        let match = param.dependencies;
        let mbFacilityMapKey = match.mbFacilityMapKey;
        if (mbFacilityMapKey !== undefined) {
          return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getFacilityMap(mbFacilityMapKey), param => {
            let doc = param[0];
            dispatch({
              TAG: "FacilityMapReceived",
              _0: doc.key,
              _1: doc.rev.body.contents,
              _2: param[1]
            });
          }, err => {
            console.error("getFacilityMap failed", err);
            Barrier$LumiAuthentication.checkServerError(err, toAuth);
          });
        } else {
          Stdlib_Option.forEach(match.facilityInfos.map(param => {
              let defaultMapKey = Document$LumiStore.contents(param.facility).defaultMap;
              if (defaultMapKey !== undefined) {
                return [Document$LumiStore.Key.coerce(defaultMapKey)];
              } else {
                return Stallingsnet$LumiCentral.FacilityInfo.sortedMaps(param.maps).map(prim => prim[0]);
              }
            }).flat()[0], facilityMapKey => LumiRoute.followUrl(facilityMapUrl(facilityMapKey, undefined), undefined));
          return;
        }
      }
    };
  }, undefined, (old, $$new) => {
    if (Primitive_object.equal(old.mbFacilityMapKey, $$new.mbFacilityMapKey)) {
      return {
        TAG: "Action",
        _0: "HandleSensorChanged"
      };
    } else {
      return "Reinit";
    }
  }, undefined, param => {
    let action = param.action;
    let state = param.state;
    let match = param.dependencies;
    let selectedSensorKey = match.selectedSensorKey;
    if (typeof action !== "object") {
      return {
        TAG: "Update",
        _0: calcSensorStyles(calcSelectedSensorState(state, selectedSensorKey))
      };
    }
    switch (action.TAG) {
      case "FacilityMapReceived" :
        let facilityMapKey = action._0;
        return {
          TAG: "Update",
          _0: calcSensorStyles({
            facilityMap: action._1,
            facilityInfo: match.facilityInfos.find(param => Belt_Map.has(param.maps, facilityMapKey)),
            sensorInfos: action._2,
            sensorStyles: state.sensorStyles,
            sensorStates: state.sensorStates,
            selectedSensorState: state.selectedSensorState
          })
        };
      case "SensorStatesReceived" :
        return {
          TAG: "Update",
          _0: calcSensorStyles(calcSelectedSensorState({
            facilityMap: state.facilityMap,
            facilityInfo: state.facilityInfo,
            sensorInfos: state.sensorInfos,
            sensorStyles: state.sensorStyles,
            sensorStates: action._0,
            selectedSensorState: state.selectedSensorState
          }, selectedSensorKey))
        };
      case "SelectSensor" :
        let mbSensorKey = action._0;
        return {
          TAG: "Effect",
          _0: param => {
            if (mbFacilityMapKey !== undefined) {
              LumiRoute.followUrl(facilityMapUrl(mbFacilityMapKey, Primitive_option.some(mbSensorKey)), undefined);
            }
          }
        };
    }
  });
  let dispatch = reducer.dispatch;
  let mbFacilityMapKey$1 = reducer.dependencies.mbFacilityMapKey;
  LumiReact.usePeriodic(5000, 60000, next => {
    if (mbFacilityMapKey$1 !== undefined) {
      return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getFacilityMapStatus(mbFacilityMapKey$1), sensorStates => {
        dispatch({
          TAG: "SensorStatesReceived",
          _0: sensorStates
        });
        next(true);
      }, err => {
        console.error("getFacilityMapStatus failed", err);
        Barrier$LumiAuthentication.checkServerError(err, toAuth);
        next(false);
      });
    }
  }, [mbFacilityMapKey$1]);
  return reducer;
}

function FacilityMap$Sidebar(props) {
  let __children = props.children;
  let facilityMapUrl = props.facilityMapUrl;
  let match = props.facilityMaps;
  let state = match.state;
  let mbFacilityMapKey = match.dependencies.mbFacilityMapKey;
  let children = __children !== undefined ? __children : null;
  let accountDoc = Barrier$LumiAuthentication.Account.useContext();
  let facilitiesWithMaps = props.facilityInfos.filter(param => Belt_Map.isEmpty(param.maps) === false);
  let mbFacility = Stdlib_Option.map(state.facilityInfo, param => Document$LumiStore.contents(param.facility));
  let len = facilitiesWithMaps.length;
  let tmp;
  tmp = mbFacility !== undefined && mbFacility.operationalState === "InitialTrainingPeriod" ? JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
            name: "wand-magic-sparkles"
          }),
          className: "panel-icon has-text-info"
        }),
        JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: "FacilityInInitialTrainingPeriod"
        })
      ],
      className: "panel-block"
    }) : null;
  let match$1 = state.facilityInfo;
  let tmp$1;
  if (match$1 !== undefined) {
    let maps = match$1.maps;
    tmp$1 = Belt_Map.size(maps) > 1 ? Stallingsnet$LumiCentral.FacilityInfo.sortedMaps(maps).map(param => {
        let facilityMapKey = param[0];
        return JsxRuntime.jsxs("a", {
          children: [
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "map"
              }),
              className: "panel-icon"
            }),
            param[1].name
          ],
          className: LumiReact.classList([
            [
              "panel-block",
              true
            ],
            [
              "is-active",
              mbFacilityMapKey !== undefined ? mbFacilityMapKey === facilityMapKey : false
            ]
          ]),
          href: facilityMapUrl(facilityMapKey)
        }, Document$LumiStore.Key.toString(facilityMapKey));
      }) : null;
  } else {
    tmp$1 = null;
  }
  let facilityMap = state.facilityMap;
  let tmp$2;
  let exit = 0;
  if (facilityMap !== undefined) {
    let selectedSensorState = state.selectedSensorState;
    if (selectedSensorState !== undefined) {
      tmp$2 = JsxRuntime.jsx(SpotDetails$Dashboard.make, {
        facilityMap: facilityMap,
        selectedSensorState: selectedSensorState,
        toApplication: props.toApplication
      });
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$2 = JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
            name: "hand-pointer"
          }),
          className: "panel-icon"
        }),
        JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: "SelectASpotForMoreInformation"
        })
      ],
      className: "panel-block"
    });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("nav", {
      children: [
        JsxRuntime.jsx("p", {
          children: mbFacility !== undefined ? Facility$LumiDocuments.Facility.getDashboardName(mbFacility) : JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
              entry: "Loading"
            }),
          className: "panel-heading is-primary"
        }),
        len !== 1 ? (
            len !== 0 ? JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                      name: "industry"
                    }),
                    className: "panel-icon"
                  }),
                  JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsxs("select", {
                      children: [
                        JsxRuntime.jsx("option", {
                          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                            entry: "SwitchFacility"
                          }),
                          value: ""
                        }),
                        facilitiesWithMaps.map(param => {
                          let facilityDoc = param.facility;
                          let defaultMapKey = Document$LumiStore.contents(facilityDoc).defaultMap;
                          let firstMap = defaultMapKey !== undefined ? Document$LumiStore.Key.coerce(defaultMapKey) : Stallingsnet$LumiCentral.FacilityInfo.sortedMaps(param.maps)[0][0];
                          return JsxRuntime.jsx("option", {
                            children: Facility$LumiDocuments.Facility.getDashboardName(Document$LumiStore.contents(facilityDoc)),
                            value: Document$LumiStore.Key.toString(firstMap)
                          }, Document$LumiStore.Key.toString(firstMap));
                        })
                      ],
                      value: "",
                      onChange: e => Stdlib_Option.forEach(Document$LumiStore.Key.fromString(e.target.value), facilityMapKey => LumiRoute.followUrl(facilityMapUrl(facilityMapKey), undefined))
                    }),
                    className: "select is-fullwidth"
                  })
                ],
                className: "panel-block"
              }) : JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                      name: "triangle-exclamation"
                    }),
                    className: "panel-icon has-text-warning"
                  }),
                  JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                    entry: {
                      TAG: "NoAvailableFacilitiesForAccount",
                      _0: Document$LumiStore.contents(accountDoc).name
                    }
                  })
                ],
                className: "panel-block"
              })
          ) : null,
        tmp,
        tmp$1,
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: "SpotDetails"
          }),
          className: "panel-heading is-primary"
        }),
        tmp$2,
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: "Legend"
          }),
          className: "panel-heading is-primary"
        }),
        children,
        state.facilityMap !== undefined ? null : JsxRuntime.jsx(Panel$Dashboard.Loading.make, {})
      ],
      className: "panel scrollable"
    }),
    className: "column is-4-tablet is-4-desktop is-4-widescreen is-3-fullhd sidebar"
  });
}

let Sidebar = {
  make: FacilityMap$Sidebar
};

let T;

export {
  T,
  calcSelectedSensorState,
  calcSensorStyles,
  useFacilityMaps,
  Sidebar,
}
/* LumiReact Not a pure module */
